import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core'

import { Store } from '@ngrx/store'
import { TagModule } from 'primeng/tag'

import { FlxModalModule } from '@flowx/angular-ui-toolkit'
import {
  WorkflowInstanceDisplayContext,
  instanceStatusTagTypeMap,
} from '@flowx/designer/modules/integration-designer/models/workflow-instance.entity'
import { WorkflowInstanceDetailsStore } from '@flowx/designer/modules/integration-designer/workflow-integration/components/workflow-run-instance/workflow-instance-details.store'
import { WorkflowRunInstanceComponent } from '@flowx/designer/modules/integration-designer/workflow-integration/components/workflow-run-instance/workflow-run-instance.component'
import { WorkflowRunService } from '@flowx/designer/modules/integration-designer/workflow-integration/services/workflow-run.service'
import { selectAppId } from '@flowx/designer/shared/store/selectors/router.selectors'

@Component({
  selector: 'flx-workflow-instance-details-modal',
  providers: [WorkflowInstanceDetailsStore, WorkflowRunService],
  imports: [FlxModalModule, TagModule, WorkflowRunInstanceComponent],
  templateUrl: './workflow-instance-details-modal.component.html',
  host: { class: 'w-full h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowInstanceDetailsModalComponent {
  #store = inject(Store)
  #workflowInstanceDetailsStore = inject(WorkflowInstanceDetailsStore)
  #workflowRunService = inject(WorkflowRunService)

  #currentAppId = this.#store.selectSignal(selectAppId)

  workflowInstanceId = input.required<string>()
  workflowName = input<string>('')
  // Optional override for runs that live in a different app (e.g. KB store entries).
  appId = input<string>()

  hideModal = output()

  status = this.#workflowInstanceDetailsStore.status
  instanceStatusTagTypeMap = instanceStatusTagTypeMap

  constructor() {
    this.#workflowRunService.init()
    this.#workflowInstanceDetailsStore.setContext(WorkflowInstanceDisplayContext.RUNTIME)

    effect(() => {
      const workflowInstanceId = this.workflowInstanceId()
      if (workflowInstanceId) {
        this.#workflowInstanceDetailsStore.getWorkflowInstance(
          workflowInstanceId,
          this.appId() ?? this.#currentAppId()
        )
      }
    })
  }
}
